import React, { Component } from 'react'
import { Modal, Button, Alert } from 'react-bootstrap'

export default class ConfirmHandleResponseModal extends Component {
  constructor() {
    super()
    this.state = { show: false, errorMessage: '' }
  }

  show(confirm, onSuccess) {
    this.setState({ show: true, confirm: confirm, onSuccess: onSuccess })
  }

  close() {
    this.setState({ show: false, errorMessage: '' })
  }

  onCancel() {
    this.close()
  }

  onConfirm() {
    this.state
      .confirm()
      .then(() => {
        if (this.state.onSuccess) {
          this.state.onSuccess()
          this.close()
        }
      })
      .catch((error) => this.setState({ errorMessage: error.response.data.message }))
  }

  render() {
    const { errorMessage } = this.state
    return (
      <div>
        <Modal show={this.state.show} onHide={() => this.onCancel()}>
          <Modal.Header>
            <Modal.Title>Bevestiging</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            {errorMessage && <Alert bsStyle="danger">{errorMessage}</Alert>}
            <span>{this.props.message}</span>
          </Modal.Body>

          <Modal.Footer>
            <Button bsStyle="danger" onClick={() => this.onCancel()} id="cancel">
              Nee
            </Button>
            <Button bsStyle="success" onClick={() => this.onConfirm()} id="confirm">
              Ja
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    )
  }
}
